import { curry } from "ramda";
import React from "react";
import { Subject } from "rxjs";

type AlertMessage =
  | { message: React.ReactNode | string }
  | { title: string; message: React.ReactNode | string };

type NotificationEvents = {
  kind: "toast";
  type: "success" | "error" | "warning" | "info";
  params: AlertMessage & { onClose?: () => void; autoHideDuration?: number };
};

export const NotificationSubject = new Subject<NotificationEvents>();

/**
 * Shows a toast notification
 */
export const notify = curry(
  (type: NotificationEvents["type"], params: NotificationEvents["params"]) => {
    NotificationSubject.next({ kind: "toast", type, params });
  }
);
